module.exports = __webpack_public_path__ + "img/i_my_menu_06.25fee1c8.svg";